import {ReactElement, useEffect, useRef, useState} from 'react';
import {LinearProgress} from '@mui/material';

type Props = {
  duration: number;
};

const INTERVAL = 16;

export default function TimeProgress({duration}: Props): ReactElement {
  const [progress, setProgress] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(
    function () {
      intervalRef.current = setInterval(function () {
        setProgress((progress) => progress + 100 / INTERVAL);
      }, duration / INTERVAL);

      return function () {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }
      };
    },
    [duration]
  );

  useEffect(
    function () {
      if (progress >= 100) {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }
      }
    },
    [progress]
  );

  return <LinearProgress value={progress} variant="determinate" />;
}
